module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/bottom-done-35a090fedce442b17cc8b33aaa26a438.svg";